// True when a loan document is flagged hidden. The backend field `isHidden`
// may be absent, a real boolean, or the legacy string "true"/"True" — accept
// all three so the FE behaves consistently regardless of how it's stored.
// Use this everywhere files are listed so hidden docs stay out of sight
// (mirrors the Document Manager's `isDocHidden`).
export const isDocHidden = (doc) => {
  const v = doc?.isHidden;
  if (typeof v === "boolean") return v;
  if (typeof v === "string") return v === "true" || v === "True";
  return false;
};
